module.exports = __webpack_public_path__ + "img/slow_logo.db27cf67.png";